export const navigationUrls = {
  home: "/",
  login: "/login",
  "the-roka": "/the-roka",
  sf: "/sf",
};
